module.exports = __webpack_public_path__ + "img/customerLogo7.42a51296.png";